export default __webpack_public_path__ + "static/media/section4.8897f04b.png";